import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import ChooseEntry from '../pages/choose/ChooseEntry.vue'/* 选妃入口 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/mine/details.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import LotteryEntry from '../pages/lottery/Entry.vue'/* 开奖入口页 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import VoteRecord  from '../pages/lottery/VoteRecord.vue'/* 投票记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import VipDetails from '../pages/mine/VipDetails.vue'/* VIP详情 */


Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'Front Page'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'Home'}},
	{path:'/ChooseEntry',name:'chooseEntry',component:ChooseEntry,meta:{title:'Choose Entry'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'Choose'}},
	{path:'/List',name:'list',component:List,meta:{title:'Choose List'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'Profile Details'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'Mine'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'Video'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'Game'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'Login'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'Register'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'Online Service'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'Online Service'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'Settings'}},
    {path:'/VipDetails',name:'VipDetails',component:VipDetails,meta:{title:'VIP Details'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'Basic Information'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'Edit Real Name'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'Edit Gender'}},
    {path:'/Language',name:'Language',component:Language,meta:{title:'Language'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'Recharge'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'Payment Password'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'Login Password'}},
    {path:'/LotteryEntry',name:'lotteryEntry',component:LotteryEntry,meta:{title:'Verification'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'Details'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'Announcements'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'Video Player'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'Bank Card'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'Wallet Network'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'Withdrawal'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'Personal Report'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'Withdraw Record'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'Game Record'}},
	{path:'/VoteRecord',name:'VoteRecord',component:VoteRecord,meta:{title:'Vote Record'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    document.title = to.matched[0].meta.title
    next()
})

export default router